"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipsReportSchema = exports.TipsByHourRowSchema = exports.TipsByDayRowSchema = exports.TipsByEmployeeRowSchema = void 0;
const zod_1 = require("zod");
exports.TipsByEmployeeRowSchema = zod_1.z.object({
    employeeId: zod_1.z.string(),
    employeeName: zod_1.z.string(),
    totalTips: zod_1.z.number(),
    transactionCount: zod_1.z.number(),
    avgTipPct: zod_1.z.number(),
});
exports.TipsByDayRowSchema = zod_1.z.object({
    dayOfWeek: zod_1.z.number(),
    dayLabel: zod_1.z.string(),
    totalTips: zod_1.z.number(),
    transactionCount: zod_1.z.number(),
});
exports.TipsByHourRowSchema = zod_1.z.object({
    hour: zod_1.z.number(),
    totalTips: zod_1.z.number(),
    transactionCount: zod_1.z.number(),
});
exports.TipsReportSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    locationId: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    totalTips: zod_1.z.number(),
    avgTipPct: zod_1.z.number(),
    cashTips: zod_1.z.number(),
    cardTips: zod_1.z.number(),
    tipToSalesRatio: zod_1.z.number(),
    byEmployee: zod_1.z.array(exports.TipsByEmployeeRowSchema),
    byDayOfWeek: zod_1.z.array(exports.TipsByDayRowSchema),
    byHour: zod_1.z.array(exports.TipsByHourRowSchema),
});
//# sourceMappingURL=tips-report.schema.js.map